module.exports = __webpack_public_path__ + "img/lock.de0814.svg";